<template>
    <v-container>
        <InitialLoading :init-loading='initLoading' />
        <v-row>
            <v-col cols='12'>
                <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>
                    <span>ارسال مدارک احراز هویت کاربر</span>
                </h3>
                <InfoAlert>
                    <div slot='default'>
                        <p class='mb-2 font-weight-bold'>در این فرم میتواند تصاویر مدارک زیر را ارسال نمایید</p>
                        <ul class='pl-0 pr-4'>
                            <li>
                                <span class='text--primary'>تصاویر کارت ملی (پشت و رو)</span>
                            </li>
                            <li>
                                <span class='text--primary'>تصاویر شناسنامه</span>
                            </li>
                            <li v-if='user.agent && false'>
                                <span class='text--primary'>تصاویر قرارداد همکاری نماینده</span>
                            </li>
                            <li v-if='user.agent  && false'>
                                <span class='text--primary'>در صورتی که نماینده ملکبا هستید لازم است برگه قرارداد همکاری نماینده را دانلود کرده و پرینت کرده و پس از تکمیل اطلاعات تصاویر اسکن شده آن را بارگذاری نمایید</span>
                            </li>
                        </ul>
                    </div>
                    <template slot='action' v-if='user.agent  && false'>
                        <v-btn
                            :block='$vuetify.breakpoint.smAndDown'
                            color='primary'
                            class='mb-2 mb-md-0'
                            outlined
                            href='/قرارداد-پیمان-نماینده-ملکبا.pdf'
                            download
                        >
                            دانلود برگه قرارداد همکاری نماینده
                        </v-btn>
                    </template>
                </InfoAlert>
            </v-col>
        </v-row>
        <v-row v-if='!initLoading'>
            <v-col>
                <v-card :disabled='IdCardPhotoLoading' :loading='IdCardPhotoLoading'>
                    <v-card-text>
                        <v-row>
                            <v-col cols='12'>
                                <v-card-subtitle>
                                    <v-icon color='red' class='ml-1' small>mdi-alert-outline</v-icon>
                                    <span>فرمت های قابل پذیرش : 'png' 'jpg' 'jpeg' 'gif' 'bmp' </span>
                                </v-card-subtitle>
                            </v-col>
                            <v-col cols='12'>
                                <ImageUploader
                                    :disableUploadPhotoLength='10'
                                    label=' تصاویر کارت ملی و شناسنامه'
                                    target='id_card--'
                                    v-model='model.userDocs.items'
                                    class='pa-3'
                                />
                            </v-col>
                            <v-col cols='12' v-if='user.agent && false'>
                                <ImageUploader
                                    :disableUploadPhotoLength='10'
                                    label='تصاویر قرارداد همکاری نماینده'
                                    target='birthCertificate--'
                                    v-model='model.agentDocs.items'
                                    class='pa-3'
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            :disabled='disableSubmitForm'
                            :loading='IdCardPhotoLoading'
                            color='primary'
                            @click='submitIdCardPhotos'
                        >
                            ثبت
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>

        </v-row>
    </v-container>
</template>

<script>
    import ImageUploader from '@/components/ImageUploader';
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';
    import InfoAlert from '@/components/Alerts/InfoAlert';
    import ErrorDialog from '@/components/ErrorDialog';
    import InitialLoading from '@/components/initialLoading';

    export default {
        name: 'AuthenticationDocumentsForm',
        components: { InitialLoading, ErrorDialog, InfoAlert, ImageUploader },
        data: () => ({
            initLoading: true,

            error: null,
            errorDialog: false,
            model: {
                userDocs: {
                    status: '',
                    items: []
                },
                agentDocs: {
                    status: '',
                    items: []
                }

            },
            IdCardPhotoLoading: false
        }),
        methods: {
            async getUserDocs() {
                await axios
                    .get('/api/users/authentication_documents')
                    .then(res => {
                        this.model = res.data;
                    })
                    .catch(error => {
                        console.error(error);
                        if (error && error.response) this.error = error.response;
                        this.errorDialog = true;
                    });
            },
            async submitIdCardPhotos() {
                this.IdCardPhotoLoading = true;
                await axios
                    .put(
                        '/api/users/authentication_documents',
                        {
                            userDocs: this.model.userDocs.items,
                            agentDocs: this.model.agentDocs.items
                        }
                    )
                    .then(() => {
                        this.$snackbar.showMessage({
                            content: 'مدارک احراز هویت',
                            color: 'success'
                        });
                    })
                    .catch(error => {
                        console.error(error);
                        if (error && error.response) this.error = error.response;
                        this.errorDialog = true;
                    });
                this.IdCardPhotoLoading = false;
            },
            ...mapActions([
                'setUser', 'showBreadCrumbs', 'setBreadCrumbsTemp'
            ])
        },
        async created() {
            await this.setBreadCrumbsTemp({
                key: 'authenticationDocumentsForm',
                value: {
                    text: `احراز هویت کاربر`,
                    href: `/Profile/authenticationDocumentsForm`
                }
            });

        },
        async updated() {
            await this.showBreadCrumbs(['profile', 'authenticationDocumentsForm']);
        },
        async mounted() {
            await this.getUserDocs();
            this.initLoading = false;
        },
        computed: {
            disableSubmitForm() {
                return this.model.userDocs && this.model.userDocs.length < 2;
            },

            ...mapState({
                user: state => state.user
            })
        }

    };
</script>

<style scoped>

</style>